module.exports = __webpack_public_path__ + "static/img/industriesbg7.d5acfad.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/industriesbg7.jpg
// module id = ztHX
// module chunks = 1